import React from 'react';
import { Route, Redirect, RouteComponentProps } from 'react-router-dom';
import { useDetectIsLogged } from '../../helpers/getUser';
import { useRouteHelper } from '../../hooks/routesHelpers';

export default function PrivateRoute({ component, location, ...rest }: { component: React.ComponentType<RouteComponentProps>; location?: string }) {
  const isLogged = useDetectIsLogged();
  const { getRoute } = useRouteHelper();
  const Component = component;
  if (!isLogged) {
    return (
      <Redirect
        to={{
          pathname: getRoute('account.login'),
          state: { from: location },
        }}
      />
    );
  }
  return <Route {...rest} render={(props) => <Component {...props} />} />;
}
